if (!customElements.get('sliding-buttons')) {
  class SlidingButtons extends HTMLElement {
    constructor() {
      super();
    }

    get value() {
      return this.input.value;
    }

    set value(newValue) {
      this.input.value = newValue;
      this.querySelectorAll('.js-button').forEach((button) => {
        if (button.getAttribute('data-value') === newValue) {
          button.classList.add('active');
        } else {
          button.classList.remove('active');
        }
      });
      this.slideBackground();
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    connectedCallback() {
      this.input = this.querySelector('input[type="hidden"]');
      this.value = this.input.value || this.querySelector('.js-button').getAttribute('data-value');

      // Add click event listeners to buttons
      this.querySelectorAll('.js-button').forEach((button) => {
        // Hide options if the default active button has a data-hide attribute
        if (button.classList.contains('active') && button.hasAttribute('data-hide')) {
          this.hideButtonsAndSummary(button.dataset.hide);
        }

        button.addEventListener('click', (event) => {
          event.preventDefault();
          this.value = button.getAttribute('data-value');

          // Hide another element if specified
          if (event.target.hasAttribute('data-hide')) {
            this.hideButtonsAndSummary(event.target.dataset.hide);
          }

          // Show another element if specified
          if (event.target.hasAttribute('data-show')) {
            this.showButtonsAndSummary(event.target.dataset.show);
          }
        });
      });

      // Listen for changes on the hidden input
      this.addEventListener('change', (event) => this.onChange(event));

      // Initial setup
      this.updateSummary();

      // Slide background after a short delay to ensure layout is ready
      setTimeout(() => {
        this.slideBackground();
      }, 100);

      // Update sliding background on resize
      new ResizeObserver((entries) => {
        for (const entry of entries) {
          this.slideBackground();
        }
      }).observe(this);
    }

    onChange() {
      this.updateSummary();
    }

    updateSummary() {
      const summaryTarget = document.querySelector(
        `[data-summary="${this.dataset.updateSummary}"]`,
      );

      if (!summaryTarget) {
        return;
      }

      summaryTarget.innerText = this.querySelector('.js-button.active').dataset.valueToUpdate;
    }

    /**
     * Slide the background to the active button
     */
    slideBackground() {
      const activeButton = this.querySelector('.js-button.active');
      const slidingBackground = this.querySelector('.js-sliding-background');

      if (activeButton && slidingBackground) {
        const buttonRect = activeButton.getBoundingClientRect();
        const containerRect = this.getBoundingClientRect();

        slidingBackground.style.width = `${Math.ceil(buttonRect.width)}px`;
        slidingBackground.style.transform = `translateX(${buttonRect.left - containerRect.left}px)`;
      }
    }

    /**
     * Hide the buttons and summary for a given name
     *
     * @param {String} name
     */
    hideButtonsAndSummary(name) {
      const buttons = document.querySelector(`[data-update-summary="${name}"]`);
      const summary = document.querySelector(`[data-summary="${name}"]`);

      if (!buttons || !summary) return;

      buttons.closest('.sliding-buttons-wrapper').classList.add('hidden');
      summary.closest('.subscription-flow__summary-row').classList.add('hidden');
    }

    /**
     * Show the buttons and summary for a given name
     *
     * @param {String} name
     */
    showButtonsAndSummary(name) {
      const buttons = document.querySelector(`[data-update-summary="${name}"]`);
      const summary = document.querySelector(`[data-summary="${name}"]`);

      if (!buttons || !summary) return;

      buttons.closest('.sliding-buttons-wrapper').classList.remove('hidden');
      summary.closest('.subscription-flow__summary-row').classList.remove('hidden');
      buttons.slideBackground();
    }
  }
  customElements.define('sliding-buttons', SlidingButtons);
}
